export default __webpack_public_path__ + "static/media/global-user-map-new.bf9d74ea.png";